import React, { useMemo } from 'react';
import { UseFormRegisterReturn, UseFormStateReturn } from 'react-hook-form';
import { AddressNoteForm } from '../../hooks/validations/useAddressNoteValidationForm';
import { useLanguage } from '../../locale/useLanguage';
import { AddressType } from '../../models';
import {
  RadioButtonGroup,
  RadioButtonGroupOption,
} from '../RadioButtonGroup/RadioButtonGroup';
import { TextField } from '../TextField/TextField';

import './AddressInstructions.css';

type AddressInstructionsProps = {
  addressType: AddressType | undefined;
  onAddressTypeChange: (val: AddressType) => void;
  intercomNameValidation: UseFormRegisterReturn;
  floorValidation: UseFormRegisterReturn;
  hasElevatorValidation: UseFormRegisterReturn;
  notesValidation: UseFormRegisterReturn;
  errors: UseFormStateReturn<AddressNoteForm>['errors'];
};

export const AddressInstructions: React.FC<AddressInstructionsProps> = ({
  addressType,
  errors,
  floorValidation,
  hasElevatorValidation,
  intercomNameValidation,
  notesValidation,
  onAddressTypeChange,
}) => {
  const [t] = useLanguage();

  const addressTypeOptions: RadioButtonGroupOption<AddressType>[] = useMemo(
    () => [
      {
        label: t('addressNotesView.addressTypePrivate'),
        value: AddressType.Private,
      },
      {
        label: t('addressNotesView.addressTypeCompany'),
        value: AddressType.Company,
      },
    ],
    [t]
  );

  return (
    <>
      <div className="address-instructions--header-container">
        <h2 className="subtitle">{t('addressNotesView.title')}</h2>
        <p className="paragraph">{t('addressNotesView.description')}</p>
      </div>
      <div className="address-instructions--field-container">
        <label className="address-instructions--label-style address-instructions--label-container">
          {t('addressNotesView.addressType')}
        </label>
        <RadioButtonGroup
          options={addressTypeOptions}
          selectedValue={addressType}
          onChangeValue={onAddressTypeChange}
        />
      </div>
      <div className="address-instructions--field-container">
        <TextField
          {...intercomNameValidation}
          placeholder={t('addressNotesView.intercomNameInputLabel')}
          error={errors.intercomName?.message}
        />
      </div>
      <div className="address-instructions--field-container">
        <TextField
          {...floorValidation}
          type="number"
          placeholder={t('addressNotesView.floorInputLabel')}
          error={errors.floor?.message}
        />
      </div>
      <div className="address-instructions--checkbox-container">
        <input {...hasElevatorValidation} type="checkbox" id="elevator" />
        <label htmlFor="elevator">{t('addressNotesView.elevator')}</label>
      </div>
      <div className="address-instructions--checkbox-container">
        <textarea
          {...notesValidation}
          placeholder={t('addressNotesView.instructionsInputLabel')}
          rows={4}
          className="textarea"
        />
      </div>
    </>
  );
};
